var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomPromptStep = function SvgCustomPromptStep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    style: {
      color: "#2d4e6d"
    }
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#custom_prompt_step_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.527 1.194c.39-.391.92-.61 1.473-.61h5.448c.553 0 1.083.22 1.473.61l1.61 1.61a.75.75 0 0 1-1.061 1.06l-1.61-1.61a.584.584 0 0 0-.412-.17H4a.583.583 0 0 0-.583.583v10.666a.583.583 0 0 0 .583.584h8a.583.583 0 0 0 .584-.583.75.75 0 0 1 1.5 0A2.083 2.083 0 0 1 12 15.417H4a2.083 2.083 0 0 1-2.083-2.083V2.667c0-.553.22-1.083.61-1.473ZM4.584 12a.75.75 0 0 1 .75-.75H6a.75.75 0 0 1 0 1.5h-.666a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.132 5.158a2.075 2.075 0 0 1 2.26 3.384l-3.355 3.354c-.237.237-.53.41-.851.504l-1.922.56a.988.988 0 0 1-1.224-1.224l.56-1.922c.094-.321.267-.614.504-.85l3.354-3.356c.193-.193.422-.346.674-.45Zm.794 1.148a.77.77 0 0 0-.544.225l-3.355 3.356a.688.688 0 0 0-.174.293l-.398 1.365 1.365-.398a.686.686 0 0 0 .293-.174L14.47 7.62a.773.773 0 0 0 .166-.838.77.77 0 0 0-.71-.475Zm-5.027 5.401Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "custom_prompt_step_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgCustomPromptStep;